import { inject, injectable } from 'inversify'
import { dataFetcher } from '../../Utils/dataFetcher'
import type { ConfigProvider } from '../../Base/ConfigProvider'
import { SERVICES } from '../../Base/serviceRegistration'
import { LotApiRequest } from '../Models/LotApiRequest'
import { LotApiResult } from '../Models/LotApiResult'
import { LotFetchService } from './LotFetchService'

@injectable()
export class LotFetchAPIService implements LotFetchService {
  @inject(SERVICES.ConfigProvider)
  private configProvider?: ConfigProvider

  async getLot(request: LotApiRequest): Promise<LotApiResult> {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const config = this.configProvider!.getConfig()

    const url = `${config.lotApi.endpoint}/?languageid=${request.languageId || ''}&objectid=${
      request.objectId || ''
    }&saleroomcode=${request.saleRoomCode || ''}&geolocation=${request.geoLocation || ''}&apiKey=${config.lotApi.key}`
    const result = await dataFetcher<LotApiResult>(url)
    return result.data as LotApiResult
  }
}

//  DON'T DELETE - used by DW
